import { useCallback } from 'react'
import { isClient } from '~/utils/envChecks'
import { isSameLocation, type LocationIdentifier } from '~/utils/locationComparison'

export function useLocationChanged(
  parseFromUrl: (searchParams: URLSearchParams) => LocationIdentifier
): (newLocation: LocationIdentifier) => boolean {
  return useCallback(
    (newLocation: LocationIdentifier) => {
      // Read the URL at call time rather than at mount: the search form is reused
      // as the "edit search" widget on results pages without remounting, so a
      // value captured once at mount would go stale after the first submit.
      let previousLocation: LocationIdentifier
      if (isClient()) {
        previousLocation = parseFromUrl(new URLSearchParams(window.location.search))
      }

      return !isSameLocation(previousLocation, newLocation)
    },
    [parseFromUrl]
  )
}
